export default __webpack_public_path__ + "static/media/radius-circle-shape.4bf5096d.png";